module.exports = __webpack_public_path__ + "img/3.c132ddd8.png";